module.exports = __webpack_public_path__ + "Flag-418.ec53b1fd5ef9f399932f839203d4a5cb.svg";